import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { ReactNode } from "react";

type PressableDashedBoxProps = {
  onClick: () => void;
  children: ReactNode;
  icon: IconDefinition;
};

export function PressableDashedBox({
  onClick,
  children,
  icon,
}: PressableDashedBoxProps) {
  return (
    <button
      className={clsx(
        "flex",
        "flex-row",
        "w-full",
        "gap-2",
        "justify-center",
        "items-center",
        "border",
        "border-neutral",
        "border-dashed",
        "bg-white",
        "rounded-md",
      )}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} className="text-base text-primary" />
      <div className="text-primary py-3 font-medium">{children}</div>
    </button>
  );
}
